
import FormPeriod from "./FormPeriod";
import TablePeriod from "./TablePeriod";
import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import {fetchPeriods} from "../../store/actions/RentalPeriodAction";
import {notification} from "antd";

function RentalPeriod({lot}) {
  const { periods, loading, error } = useSelector(state => state.rentalPeriods);
  const dispatch = useDispatch();

  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    dispatch(fetchPeriods(lot.lot_id));
  }, [dispatch, lot.lot_id]);

  useEffect(() => {
    if (error) {
      api.error({
        message: 'Tarification période',
        description: error,
        placement: 'topRight',
      });
    }
  }, [error, api]);

  return (
    <>
      {contextHolder}
        <FormPeriod lot_id={lot.lot_id} />
        <TablePeriod loading={loading} periods={periods} />
    </>
  );
}

export default RentalPeriod;